/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import { green } from '@material-ui/core/colors';

export const palette = {
  /* By convention, MUI uses dark variant on hover */
  primary: {
    main: '#066AE3',
    contrastText: '#FFF',
    hover: '#1976D2',
    active: '#084FA6',
    border: '#EEEFF2',
    get dark() {
      return this.hover;
    },
    disabled: '#BBDEFB',
    hoverContrastText: '#FFF',
    activeText: '#FFF',
    disabledText: '#FFF',
  },
  secondary: {
    main: '#D9DDE3',
    contrastText: '#21252C',
    hover: '#EEEFF2',
    hoverContrastText: '#21252C',
    active: '#BFC6CF',
    disabled: '#F6F7F8',
    disabledText: '#738296',
    get dark() {
      return this.hover;
    },
  },
  tertiary: {
    main: '#404955',
    contrastText: '#FFF',
    hover: '#677589',
    active: '#21252C',
    get dark() {
      return this.hover;
    },
  },
  inverted: {
    main: '#FFF',
    contrastText: '#21252C',
    hover: '#F6F7F8',
    active: '#BFC6CF',
    disabled: '#F6F7F8',
    disabledText: '#738296',
    get dark() {
      return this.hover;
    },
  },
  avatar: {
    primary: {
      text: '#FFF',
      background: '#404955',
    },
    secondary: {
      text: '#FFF',
      background: '#404955',
    },
  },
  completed: '#29623B',
  failed: '#CE4722',
  focus: '#1976D2',
  sidebarFocus: '#1976D2', // area: main menu
  userAccountHeader: '#8AC4FF', // area: user account header
  sidebarFocusBorder: '#FFF', // area: main menu
  headerLogoSeparator: '#E7EEF4', // area: header // logo separator line
  titleText: '#21252C', // area: typography
  mainText: '#21252C', // area: typography
  welcomeText: '#21252C',
  welcomeTextContrast: '#21252C',
  buttonTextHover: '#1976D2',
  lightBorder: '#677289',
  dashboardLabel: '#677289',
  sideMenuText: '#21252C',
  sideMenuHoverText: '#21252C',
  sideMenuHoverBackground: '#f0f0f0',
  sideMenuProgressBackground: 'rgba(0,0,0,0.1)',
  inProgressBackgroundActive: '#D9DDE3',
  completedProgressBackground: '#738296',
  completedProgressBackgroundActive: '#738296',
  previewSubmissionButton: '#066AE3',
  previewSubmissionButtonText: '#FFF',
  previewSubmissionButtonHover: '#1976D2',
  activeNavBarButtonBackground: '#066AE3', // area: main menu // active 1st level menu element background
  activeNavBarButtonText: '#FFF', // area: main menu // active 1st level menu text
  expandedNavBarButton: '#0D47A1', // area: main menu // selected dropdown item level 1 background in expanded menu - rename to sidebar...
  expandedTextColor: '#FFF', // area: main menu // selected dropdown item level 1 color in expanded menu - rename to sidebar...
  tooltipBackground: '#404955', // area: components // tooltip background
  footerText: '#21252C',
  footerBackground: '#DFE5E9', // area: components  // footer + sticky bar background, refactor with theme.palette.contrastBackground
  scrollLink: 'rgba(0,0,0,0.87)',
  mainBackground: '#FCFCFD',
  contrastText: '#21252C',
  contrastBackground: '#DFE5E9',
  tab: '#21252C',
  tabSectionUnderline: '#21252C',
  tabActive: '#066AE3',
  cardActive: '#D1E3FA', // area: components // card for selecting file to preview
  cardActiveBorder: '#0D47A1', // area: components // card for selecting file to preview
  selectedIconButton: '#0D47A1',
  keyboardFocusBackground: '#D1E3FA', // area: components // background for selectable containers like dropzone
  input: '#677289',
  checkbox: '#738296',
  checkboxUnchecked: '#BFC6CF',
  checkboxActive: '#056AE3',
  disabledCheckbox: '#BFC6CF',
  sortActive: '#21252C',
  sortInactive: '#BFC6CF',
  sortDefault: '#677289',
  filterButtonbackground: '#F6F7F8', // area: components // table filter button
  filterButtonText: '#21252C', // area: components // table filter button
  tableMoreIconColor: '#066AE3', // area: components // more icon in table last column (move to {moreIcon})
  expandIcon: '#21252C',
  tableHover: '#D9DDE3', // area: table // row background on hover
  dropzoneBorder: '#677289',
  feeTableHeadRowBackground: '#FFF',
  error: {
    main: '#CE4722',
    background: '#FBE9E7',
    text: '#0B0C0C',
  },
  warning: {
    main: '#B8840A',
  },
  info: {
    main: '#0D47A1',
  },
  white: '#FFF',
  black: '#000',
  summaryCardHeaderText: 'rgba(0, 0, 0, 0.87)',
  darkGray: '#738296',
  lightGray: '#EEEFF2',
  emptyChart: '#EEEFF2',
  success: green,
  highlightsAndDividers: '#DFE5E9',
  tabDivider: '#677589',
  lineDivider: '#BFC6CF',
  elementBackground: '#F6F7F8', // area: components // background of multiple 'box like' elements like boxes, dropzones, cards etc, requires adding border & font color
  border: '#D9DDE3',
  iconBackground: '#D9DDE3',
  paginationIconDisabled: '#D9DDE3',
  counterBackground: '#29623B',
  disabled: '#677289',
  backgroundDisabled: '#D9DDE3',
  highlightedBackground: '#E7F1FC',
  backgroundError: '#FFE0E0',
  linkColour: '#066AE3',
  seeMoreBackground: '#D9DDE3',
  sidebarBackground: '#21252C', // area: main menu // left menu background color
  sidebarText: '#FFF', // area: main menu // color of icons (not expanded) or 1st level menu items (expanded)
  sidebarItemHoverBackground: '', // area: main menu //
  sidebarItemHoverText: '', // area: main menu //
  sidebarItemSelectedBackground: '#066AE3',
  sidebarItemSelectedText: '#FFF',
  sidebarItemSelectedBackgroundHover: '#4E91E9',
  sidebarItemSelectTextHover: '#FFF',
  sidebarSubItemText: '#FFFFFF', // area: main menu // color of text in menu subitems
  sidebarSubItemBackground: '#404955', // area: main menu // background of menu subitems
  sidebarSubItemHoverBackground: '', // area: main menu //
  sidebarSubItemHoverText: '', // area: main menu //
  sidebarHighlightBackground: '#D1E3FA', // area: main menu // highlight on the right for active item
  submissionOverviewCardHighlight: '#084FA6',
  defaultOverviewCardHighlight: '#9BBDE6',
  profileSectionUsername: '#000',
  visitedLink: '#8652AF',
  statusChip: {
    DRAFT: { main: '#F6C452', contrastText: '#21252C' },
    READY_TO_SIGN: { main: '#68C6DE', contrastText: '#21252C' },
    VALID_READY_TO_SIGN: { main: '#68C6DE', contrastText: '#21252C' },
    SENT_TO_SIGN: { main: '#BFC6CF', contrastText: '#21252C' },
    READY_TO_SEND: { main: '#BED05E', contrastText: '#21252C' },
    SENT_TO_FILING: { main: '#BFC6CF', contrastText: '#21252C' },
    SENDING_FAILED: { main: '#BED05E', contrastText: '#21252C' },
    READY_TO_PAY: { main: '#4270B1', contrastText: '#FFF' },
    PAID: { main: '#29623b', contrastText: '#FFF' },
    SIGNING_FAILED: { main: '#68C6DE', contrastText: '#21252C' },
    RESIGNING_FAILED: { main: '#4270B1', contrastText: '#ffffff' },
    PAYER: { main: '#29623B', contrastText: '#FFF' },
    SENT: { main: '#29623b', contrastText: '#FFF' },
    default: { main: '#DFE5E9', contrastText: '#21252C' },
    validBackground: '#29623B',
    invalidBackground: '#BF360C',
  },
  roleChip: {
    ADMIN: { main: 'black', contrastText: '#FFF' },
    SENDER: { main: '#BED05E', contrastText: '#21252C' },
    SIGNER: { main: '#68C6DE', contrastText: '#21252C' },
    DRAFTER: { main: '#F6C452', contrastText: '#21252C' },
    PAYER: { main: '#29623B', contrastText: '#FFF' },
    DEFAULT: { main: '#DFE5E9', contrastText: '#21252C' },
  },
  landingBackground: '#DFE5E9', // area: Login Page // login page body background
  customHelpIcon: '#404955', // area: Components // custom help icon in header cell
  validTagBackground: '#2B6697', // area: Components // tag(chip) in SelectWithSearch
  moreIcon: {
    // area: Components // more icon in table last column
    color: '#066AE3',
    backgroundColor: 'transparent',
    hover: {
      color: '#FFF',
      backgroundColor: '#1976D2',
    },
    active: {
      color: '#FFF',
      backgroundColor: '#0D47A1',
    },
    focus: {
      color: '#FFF',
      backgroundColor: '#1976D2',
    },
  },
};
